import { ProductTrackingTypeOptions } from "../../api/type";

export const OperationService = {
  getQuantity: (pType: string, amount: number) => {
    if (pType === ProductTrackingTypeOptions.SERIALIZED) {
      return 1;
    }
    return Number(amount)
  }
}